document.addEventListener("DOMContentLoaded", function () {

  const openBtn = document.getElementById("waspCompare43Open");
  const closeBtn = document.getElementById("waspCompare43Close");
  const overlay = document.getElementById("waspCompare43Overlay");

  if (!openBtn || !closeBtn || !overlay) return;

  const backdrop = overlay.querySelector(".wasp-compare-43-backdrop");
  const viewport = document.getElementById("waspCompare43Viewport");
  const nav = overlay.querySelector(".wasp-compare-43-nav");
  const navButtons = [...overlay.querySelectorAll(".wasp-compare-43-nav button")];
  const scrollArea = document.getElementById("waspCompare43Scroll");
  const cardTracks = [...overlay.querySelectorAll(".wasp-compare-43-card-track")];

  const categoryOrder = navButtons.map(btn => btn.dataset.cat);

  let categoryIndex = 0;
  let subIndexes = categoryOrder.map(() => 0);
  let maxSubByCategory = {};

  let startX = 0;
  let startY = 0;
  let isOpen = false;

  function setViewportHeight() {
    const vh = window.visualViewport
      ? window.visualViewport.height
      : window.innerHeight;

    document.documentElement.style.setProperty(
      "--wasp-compare-vh",
      vh + "px"
    );
  }

  function getSlideCount(track) {
    return track.children.length;
  }

  function removeAutoPlaceholders() {
    cardTracks.forEach(track => {
      track
        .querySelectorAll("[data-auto-placeholder='true']")
        .forEach(slide => slide.remove());
    });
  }

  function createPlaceholderSlide(cat, sub) {

    const slide = document.createElement("div");

    slide.className = "wasp-compare-43-card-slide";
    slide.dataset.cat = cat;
    slide.dataset.sub = sub;
    slide.dataset.autoPlaceholder = "true";

    slide.innerHTML =
      '<div class="wasp-compare-43-card wasp-card-media wasp-card-empty" aria-hidden="true"><div></div><div></div></div>';

    return slide;
  }

  function buildCategoryStructure() {

    removeAutoPlaceholders();

    maxSubByCategory = {};

    categoryOrder.forEach(cat => {
      maxSubByCategory[cat] = 0;
    });

    cardTracks.forEach(track => {

      [...track.children].forEach(slide => {

        const cat = slide.dataset.cat;
        const sub = Number(slide.dataset.sub || 0);

        if (!cat || !categoryOrder.includes(cat)) return;

        maxSubByCategory[cat] = Math.max(
          maxSubByCategory[cat],
          sub
        );
      });
    });

    cardTracks.forEach(track => {

      const realSlides = [...track.children];

      const slideMap = {};

      realSlides.forEach(slide => {

        const cat = slide.dataset.cat;
        const sub = Number(slide.dataset.sub || 0);

        if (!cat || !categoryOrder.includes(cat)) return;

        slideMap[`${cat}__${sub}`] = slide;
      });

      const fragment = document.createDocumentFragment();

      categoryOrder.forEach(cat => {

        const maxSub = maxSubByCategory[cat] || 0;

        for (let sub = 0; sub <= maxSub; sub++) {

          const key = `${cat}__${sub}`;

          fragment.appendChild(
            slideMap[key] || createPlaceholderSlide(cat, sub)
          );
        }
      });

      track.innerHTML = "";
      track.appendChild(fragment);
    });
  }

  function getCurrentCategory() {
    return categoryOrder[categoryIndex];
  }

  function getCurrentSlideIndex() {

    let index = 0;

    for (let i = 0; i < categoryIndex; i++) {

      const cat = categoryOrder[i];

      index += (maxSubByCategory[cat] || 0) + 1;
    }

    return index + (subIndexes[categoryIndex] || 0);
  }

  function setupTracks() {

    cardTracks.forEach(track => {

      const slideCount = getSlideCount(track);

      if (!slideCount) return;

      track.style.width = `${slideCount * 100}%`;

      [...track.children].forEach(slide => {

        slide.style.flexBasis = `${100 / slideCount}%`;
        slide.style.width = `${100 / slideCount}%`;
      });
    });
  }

function centerActiveNav(behavior) {

  const activeButton = navButtons[categoryIndex];

  if (!activeButton || !nav) return;

  requestAnimationFrame(() => {

    const navWidth = nav.clientWidth;

    const navScrollWidth = nav.scrollWidth;

    const maxScroll = Math.max(0, navScrollWidth - navWidth);

    let target =

      activeButton.offsetLeft -

      (navWidth / 2) +

      (activeButton.offsetWidth / 2);

    target = Math.max(0, Math.min(target, maxScroll));

    if (categoryIndex === 0) {

      target = 0;

    }

    if (categoryIndex === navButtons.length - 1) {

      target = maxScroll;

    }

    nav.scrollTo({

      left: target,

      behavior: behavior || "smooth"

    });

  });

}
  
    function createOrUpdateSlideHints() {

    const currentCat = getCurrentCategory();

    const maxSub = maxSubByCategory[currentCat] || 0;

    const total = maxSub + 1;

    cardTracks.forEach(track => {

      [...track.children].forEach(slide => {

        let hint = slide.querySelector(".wasp-compare-43-hint");

        if (!hint) {

          hint = document.createElement("div");

          hint.className = "wasp-compare-43-hint";

          hint.innerHTML =
  '<span class="wasp-compare-43-hint-text"></span><strong></strong>';

          slide.insertBefore(hint, slide.firstChild);
        }

        const isCurrentCategory =
          slide.dataset.cat === currentCat;

        const hasMoreSlides =
          total > 1;

        hint.classList.toggle(
          "is-visible",
          isCurrentCategory && hasMoreSlides
        );

        if (isCurrentCategory && hasMoreSlides) {

          const currentSub =
            Number(slide.dataset.sub || 0) + 1;
          const labelMap = {
  design: "Diseño",
  coverage: "Cobertura",
  cadr: "CADR",
  filter: "Filtro",
  technology: "Tecnología",
  sensor: "Sensor",
  night: "Noche",
  connectivity: "Conexión",
  consumption: "Consumo",
  size: "Tamaño",
  price: "Precio"
};

const categoryLabel =
  labelMap[currentCat] || "esta categoría";

hint.querySelector(".wasp-compare-43-hint-text").textContent =
  "Sigue viendo " + categoryLabel;

          hint.querySelector("strong").textContent =
            currentSub + "/" + total + " →";
        }
      });
    });
  }

  function updateHints() {
    createOrUpdateSlideHints();
  }

  function updateNav(shouldCenter, behavior) {

    navButtons.forEach((button, i) => {
      button.classList.toggle("active", i === categoryIndex);
    });

    if (shouldCenter && overlay.classList.contains("active")) {
      centerActiveNav(behavior);
    }
  }

  function updatePosition(shouldCenterNav, navBehavior) {

    const slideIndex = getCurrentSlideIndex();

    cardTracks.forEach(track => {

      const slideCount = getSlideCount(track);

      const percentage =
        slideCount
          ? slideIndex * (100 / slideCount)
          : 0;

      track.style.transform =
        `translate3d(-${percentage}%,0,0)`;

      const activeSlide = track.children[slideIndex];

      if (!activeSlide) return;

      const slideImg = activeSlide.dataset.img;

      if (
        slideImg &&
        slideImg !== "URL_DE_TU_IMAGEN"
      ) {

        track.style.setProperty(
          "--wasp-slide-img",
          `url("${slideImg}")`
        );

      } else {

        track.style.removeProperty("--wasp-slide-img");
      }

      const viewport =
        track.closest(".wasp-compare-43-card-viewport");

      if (!viewport) return;

      const card =
        activeSlide.querySelector(".wasp-compare-43-card");

      if (card) {
        viewport.style.height =
  activeSlide.offsetHeight + "px";
      }
    });
        updateHints();
    updateNav(shouldCenterNav, navBehavior);
  }

  function disableTrackTransitions() {

    cardTracks.forEach(track => {
      track.style.transition = "none";
    });
  }

  function restoreTrackTransitions() {

    requestAnimationFrame(() => {

      requestAnimationFrame(() => {

        cardTracks.forEach(track => {
          track.style.transition = "";
        });
      });
    });
  }

  function repairLayout(delay) {

    setTimeout(() => {

      if (overlay.classList.contains("active")) {

        repairOpenLayoutSilently();

      } else {

        repairClosedLayoutSilently();
      }

    }, delay || 0);
  }

  function resetCompareState() {

    categoryIndex = 0;

    subIndexes = categoryOrder.map(() => 0);

    nav.scrollLeft = 0;

    if (scrollArea) {
      scrollArea.scrollTop = 0;
    }

    buildCategoryStructure();

    setupTracks();

    updatePosition(false, "auto");
  }

  function repairOpenLayoutSilently() {

    setViewportHeight();

    setupTracks();

    disableTrackTransitions();

    updatePosition(true, "auto");

    restoreTrackTransitions();
  }

  function repairClosedLayoutSilently() {

    setViewportHeight();

    disableTrackTransitions();

    resetCompareState();

    restoreTrackTransitions();
  }

  function goCategory(index) {

  categoryIndex = Math.max(
    0,
    Math.min(index, categoryOrder.length - 1)
  );

  subIndexes[categoryIndex] = 0;

  updatePosition(true, "smooth");

  requestAnimationFrame(() => {
    updatePosition(true, "auto");
  });

  setTimeout(() => {
    updatePosition(true, "auto");
  }, 120);
}

  function next() {

    const currentCat = getCurrentCategory();

    const maxSub =
      maxSubByCategory[currentCat] || 0;

    if (subIndexes[categoryIndex] < maxSub) {

      subIndexes[categoryIndex]++;

    } else if (
      categoryIndex < categoryOrder.length - 1
    ) {

      categoryIndex++;

      subIndexes[categoryIndex] = 0;
    }

 updatePosition(true, "smooth");

requestAnimationFrame(() => {
  updatePosition(true, "auto");
});

setTimeout(() => {
  updatePosition(true, "auto");
}, 120);
  }

  function prev() {

    if (subIndexes[categoryIndex] > 0) {

      subIndexes[categoryIndex]--;

    } else if (categoryIndex > 0) {

      categoryIndex--;

      const previousCat =
        categoryOrder[categoryIndex];

      subIndexes[categoryIndex] =
        maxSubByCategory[previousCat] || 0;
    }

  updatePosition(true, "smooth");

requestAnimationFrame(() => {
  updatePosition(true, "auto");
});

setTimeout(() => {
  updatePosition(true, "auto");
}, 120);
  }

  function openModal() {

    setViewportHeight();

    overlay.classList.remove("closing");

    disableTrackTransitions();

    resetCompareState();

    restoreTrackTransitions();

    overlay.classList.add("active");

    document.body.classList.add(
      "wasp-compare-43-lock"
    );

    isOpen = true;

    requestAnimationFrame(() => {
      updatePosition(true, "smooth");
    });
  }

  function closeModal() {

    if (!overlay.classList.contains("active")) return;

    overlay.classList.add("closing");

    document.body.classList.remove(
      "wasp-compare-43-lock"
    );

    isOpen = false;

    setTimeout(() => {

      overlay.classList.remove("active");
      overlay.classList.remove("closing");

      repairClosedLayoutSilently();

    }, 560);
  }

  setViewportHeight();

  buildCategoryStructure();

  setupTracks();

  resetCompareState();

  openBtn.addEventListener("click", openModal);

  closeBtn.addEventListener("click", closeModal);

  backdrop?.addEventListener("click", closeModal);

  navButtons.forEach((button, index) => {

    button.addEventListener("click", () => {
      goCategory(index);
    });
  });

  if (viewport) {

    viewport.addEventListener("touchstart", e => {

      const touch = e.changedTouches[0];

      startX = touch.clientX;
      startY = touch.clientY;

    }, { passive: true });

   viewport.addEventListener("touchend", e => {

    const touch = e.changedTouches[0];

    const endX = touch.clientX;
    const endY = touch.clientY;

    const diffX = startX - endX;
    const diffY = startY - endY;

    if (
      Math.abs(diffX) > 55 &&
      Math.abs(diffX) > Math.abs(diffY)
    ) {

      if (diffX > 0) next();
      else prev();
    }

  }, { passive: true });

  let wheelLocked = false;

  viewport.addEventListener("wheel", e => {

    if (!overlay.classList.contains("active")) return;

    const horizontalMove =
      Math.abs(e.deltaX) > Math.abs(e.deltaY);

    if (!horizontalMove) return;

    if (Math.abs(e.deltaX) < 35) return;

    e.preventDefault();

    if (wheelLocked) return;

    wheelLocked = true;

    if (e.deltaX > 0) {
      next();
    } else {
      prev();
    }

    setTimeout(() => {
      wheelLocked = false;
    }, 520);

  }, { passive: false });
}

  document.addEventListener("keydown", e => {

    if (!overlay.classList.contains("active")) return;

    if (e.key === "Escape") closeModal();

    if (e.key === "ArrowRight") next();

    if (e.key === "ArrowLeft") prev();
  });

  window.addEventListener("resize", () => {
    repairLayout(80);
  });

  if (window.visualViewport) {

    window.visualViewport.addEventListener(
      "resize",
      () => repairLayout(80)
    );
  }

  window.addEventListener("orientationchange", () => {
    repairLayout(250);
  });

  window.addEventListener("pageshow", () => {

    setTimeout(() => {

      isOpen =
        overlay.classList.contains("active");

      repairLayout();

    }, 120);
  });

  document.addEventListener(
    "visibilitychange",
    () => {

      if (!document.hidden) {

        setTimeout(() => {

          isOpen =
            overlay.classList.contains("active");

          repairLayout();

        }, 160);
      }
    }
  );
});